export enum WalletStatus {
  Active = 'Active',
  Processing = 'Processing',
  Expired = 'Expired',
  TooLarge = 'Too large',
  Malformed = 'Malformed',
  Failed = 'Failed',
}

// convert wallet status saved for chain wallets to UI equivalent
export const WALLET_STATUS_KEY = {
  Loaded: WalletStatus.Active,
  Preload: WalletStatus.Active, // This seems wrong UX, but leaving as is for now
  Loading: WalletStatus.Processing,
  Failed: WalletStatus.Failed,
  TooLarge: WalletStatus.TooLarge,
}
